(function($) {
    $(document).ready(function () {
        var educatorRoleId = '11';
        var studentRoleId = '15';

        var jobRole = $('#registration_jobRole');
        var uniFields = $('#university-fields');
        var companyFields = $('#company-fields');

        if (jobRole.length === 0 || uniFields.length === 0 || companyFields.length === 0) {
            return;
        }

        if (jobRole.val() !== educatorRoleId && jobRole.val() !== studentRoleId) {
            uniFields.hide();
            companyFields.show();
        } else {
            uniFields.show();
            companyFields.hide();
        }

        jobRole.on('change', function(e) {
            if (jobRole.val() !== educatorRoleId && jobRole.val() !== studentRoleId) {
                uniFields.hide();
                companyFields.show();
            } else {
                uniFields.show();
                companyFields.hide();
            }
        });
    });
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/legacy/js/registration.js